// client/extensions/ActionbarSpacer.ts
import { ActionbarSpacer } from "../components/actionbarElements.js";
var Spacer = {
  buttons: () => [{ name: ActionbarSpacer, icon: "" }],
  extensions: []
};
export {
  Spacer
};
